export default __webpack_public_path__ + "static/media/Republique_Francaise_RVB.3877bc43.png";